import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from '@pella/sash-framework';
import { isValidArray } from '../../../utilities/validations';

const BranchDisclaimerModal = ({ isOpen, onClose, promoArray = [], disclaimer }) => {
  const convertDisclaimersToArray = () => {
	if (isValidArray(promoArray)) {
	  return promoArray.slice(0, 3).map(item => ({
		disclaimer: item?.disclaimer
	  }));
	}
	
	if (disclaimer) {
	  return [
		{ disclaimer: disclaimer.disclaimer1 },
		{ disclaimer: disclaimer.disclaimer2 },
		{ disclaimer: disclaimer.disclaimer3 }
	  ].filter(item => item.disclaimer);
	}
	
	return [];
  };

  const checkDisclaimerDuplicates = (currentDisclaimer, currentIndex, array) => {
	return !array
	  .slice(0, currentIndex)
	  .some(item => item?.disclaimer === currentDisclaimer);
  };

  const disclaimers = convertDisclaimersToArray();

  return (
	<Modal isOpen={isOpen} onClose={onClose}>
	  <Modal.Header>&nbsp;</Modal.Header>
	  <Modal.Content>
		{disclaimers.map((item, index) => (
		  item?.disclaimer &&
		  checkDisclaimerDuplicates(item.disclaimer, index, disclaimers) && (
			<div
			  key={index}
			  className={`text-body-2 before:mr-1 before:align-super before:text-[75%] before:content-["${index + 1}"]`}
			  dangerouslySetInnerHTML={{ __html: item.disclaimer }}
			/>
		  )
		))}
	  </Modal.Content>
	</Modal>
  );
};

BranchDisclaimerModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  promoArray: PropTypes.arrayOf(PropTypes.shape({
	promo: PropTypes.string,
	disclaimer: PropTypes.string,
	conjunction: PropTypes.string,
	promo_text: PropTypes.string
  })),
  disclaimer: PropTypes.shape({
	disclaimer1: PropTypes.string,
	disclaimer2: PropTypes.string,
	disclaimer3: PropTypes.string
  })
};

export default BranchDisclaimerModal;
